// extracted by mini-css-extract-plugin
export default {"itemWrapper":"JVw_HQwR","image":"I56jB5Zg","item":"PsgkLETx","extended":"ApPDRPb3","withBorder":"dKEt49l2","imageWrapper":"FMsHBsNl","infoWrapper":"aMBsKHSN","badge":"WvXq3LMP"};